import { render, staticRenderFns } from "./ListOfferPresentation.vue?vue&type=template&id=a5d1055e&scoped=true"
import script from "./ListOfferPresentation.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListOfferPresentation.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ListOfferPresentation.vue?vue&type=style&index=0&id=a5d1055e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d1055e",
  null
  
)

export default component.exports